{
  "title": "Draconic Transformation",
  "source": "Fizban's Treasury of Dragons",
  "levelAndSchool": "7th-level Transmutation",
  "level": 7,
  "castingTime": "1 Bonus Action",
  "range": "Self",
  "components": "V, S, M (a statuette of a dragon, worth at least 500 gp)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "With a roar, you draw on the magic of dragons to transform yourself, taking on draconic features. You gain the following benefits until the spell ends:",
    "Blindsight. You have blindsight with a range of 30 feet. Within that range, you can effectively see anything that isn’t behind total cover, even if you’re blinded or in darkness. Moreover, you can see an invisible creature, unless the creature successfully hides from you.",
    "Breath Weapon. When you cast this spell, and as a bonus action on subsequent turns for the duration, you can exhale shimmering energy in a 60-foot cone. Each creature in that area must make a Dexterity saving throw, taking 6d8 force damage on a failed save, or half as much damage on a successful one.",
    "Wings. Incorporeal wings sprout from your back, giving you a flying speed of 60 feet."
  ],
  "spellLists": ["druid", "sorcerer", "wizard"]
}
